import React from 'react';
import { Tooltip } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { Checkbox } from '@fortress-technology-solutions/fortress-component-library/Molecules';
import messages from '../ManageBuildings/messages';

type Props = {
  isLIHTCProperty: boolean,
  checked: boolean,
  disabled: boolean,
  onChange: Function,
  intl: Object,
};

const SingleBuildingElectionCheckbox = ({
  isLIHTCProperty,
  checked,
  disabled,
  onChange,
  intl,
}: Props) => {
  return (
    <Tooltip
      placement="left"
      title={
        isLIHTCProperty
          ? intl.formatMessage(messages.singleBuildingElectionTooltip)
          : null
      }
    >
      <Checkbox
        disabled={disabled}
        name="singleBuildingElection"
        label={intl.formatMessage(messages.singleBuildingElection)}
        checked={checked}
        onChange={(_event, value: boolean) => onChange(value)}
        formControlLabelProps={{ sx: { marginRight: 0 } }}
      />
    </Tooltip>
  );
};

export default SingleBuildingElectionCheckbox;
